import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "./ui/primitives";

// In-shell 404 — keeps the staff inside AppLayout (sidebar/topbar) instead of
// bouncing them to the public marketing page on a bad /app/* URL.
export default function NotFound() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const headingRef = useRef(null);
  // React Router v6 stores an idx in history.state; >0 means there is real in-app history.
  const canGoBack =
    typeof window !== "undefined" && (window.history.state?.idx ?? 0) > 0;

  useEffect(() => {
    document.title = "Page not found";
    headingRef.current?.focus();
  }, []);

  return (
    <div
      className="grid min-h-[60vh] place-items-center px-4 py-12 sm:py-24 text-center"
      data-testid="app-404"
    >
      <div className="w-full max-w-sm">
        <div className="w-14 h-14 rounded-2xl bg-muted grid place-items-center mx-auto mb-4">
          <Compass className="w-7 h-7 text-accent" aria-hidden="true" />
        </div>
        <h1
          ref={headingRef}
          tabIndex={-1}
          aria-describedby="nf-desc"
          className="font-heading font-bold text-ink text-xl outline-none"
        >
          Page not found
        </h1>
        <p id="nf-desc" className="text-sm text-ink-subtle mt-1.5">
          The page you’re looking for doesn’t exist or may have moved.
        </p>
        <p className="mt-2 text-xs text-ink-subtle font-mono break-all" dir="ltr">
          {pathname}
        </p>
        <div className="mt-5 flex flex-col items-stretch gap-2 sm:flex-row sm:justify-center">
          {canGoBack && (
            <Button type="button" variant="secondary" onClick={() => navigate(-1)}>
              Go back
            </Button>
          )}
          <Button
            type="button"
            onClick={() => navigate("/app/dashboard")}
            data-testid="app-404-home"
          >
            Go to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}